import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import { selectDiscountProducts } from 'selectors/entitySelector';
import { showError, removePriceMatchRows, updatePriceMatchRows } from 'actions/CommonActions';
import { clearPriceMatchRows } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import SelectInput from 'screens/components/basic/SelectInput';
import DecimalInputDiscount from 'screens/components/basic/DecimalInputDiscount';
import TextInput from 'screens/components/basic/TextInput';
import ToggleInputForTable from 'screens/components/basic/ToggleInputForTable';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import MaskedTextInputDiscount from 'screens/components/advanced/MaskedTextInputDiscount';

class POSProductDiscount extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            priceMatchRows: [],
            newPrices: {},
        };
    }

    componentDidMount() {
        this.clearNotes();
    }

    clearNotes() {
        const { products, name } = this.props;

        products.forEach(product => {
            const fieldName = `${name}OrderProductNotes-${product.id}`;
            this.props.formInput(null, fieldName);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.newPrices !== this.props.newPrices) {
            this.setState({ newPrices: prevProps.newPrices });
        }
    }

    handlePriceMatch = (productId = null, productName = null, priceMatchPlusPercentage = null, price = null) => {

        const { products, priceMatchRows = [], updatePriceMatchRows } = this.props;
        let updatedPriceMatchRows = [...priceMatchRows];
        if (productId != null) {
            const currentNewPrice = this.props.newPrices[productId] !== undefined
                ? this.props.newPrices[productId]
                : price;
            // If no current price, show error and prevent toggle change
            if (currentNewPrice === undefined && isloaded) {
                this.props.showError(this.props.t('pos.messages.priceMatchCanNotAdded'));
                return false;
            }
            const discountAmount = (currentNewPrice * (priceMatchPlusPercentage / 100)).toFixed(2);
            const newPrice = (currentNewPrice - discountAmount).toFixed(2);
            const newRow = {
                id: productId,
                Name: productName,
                CurrentPrice: currentNewPrice,
                PriceMatchPlus: priceMatchPlusPercentage,
                DiscountAmount: parseFloat(discountAmount),
                NewPrice: parseFloat(newPrice)
            };

            // Update the state based on whether the row exists or not
            this.setState(prevState => {
                const existingRows = this.props.priceMatchRows === undefined ? [] : this.props.priceMatchRows;
                const exists = existingRows.some(row => row.id === productId);
                if (!exists) {
                    this.props.updatePriceMatchRows([...existingRows, newRow]);
                }
                else {
                    this.props.removePriceMatchRows(productId);
                }
            });
            return true;
        }
        else {

            // Iterate over products to add or update rows
            products.forEach(product => {
                const { id, status, priceMatchPlusPercentage } = product;
                const existsInPriceMatchRows = updatedPriceMatchRows.some(row => row.id === id);

                if (status === 1 && priceMatchPlusPercentage > 0) {
                    if (!existsInPriceMatchRows) {
                        const discountAmount = (product.newPrice * (priceMatchPlusPercentage / 100)).toFixed(2);
                        const newPrice = (product.newPrice - product.discountAmount).toFixed(2);
                        const newRow = {
                            id: product, id,
                            Name: product.name,
                            CurrentPrice: newPrice,
                            PriceMatchPlus: priceMatchPlusPercentage,
                            DiscountAmount: parseFloat(discountAmount),
                            NewPrice: parseFloat(newPrice)
                        };
                        if (newRow) {
                            updatedPriceMatchRows.push(newRow);
                        }
                    }
                } else if (productId === id || status === 4 || priceMatchPlusPercentage === 0) {
                    updatedPriceMatchRows = updatedPriceMatchRows.filter(row => row.id !== id);
                }
            });

            // Update state only if rows have changed
            if (updatedPriceMatchRows.length !== priceMatchRows.length) {
                updatePriceMatchRows(updatedPriceMatchRows);
            }
            return updatedPriceMatchRows;
        }
    };

    getPriceMatch = () => {
        const { products, priceMatchRows = [] } = this.props;
        const updatedPriceMatchRows = [...priceMatchRows];
    
        // Add products with priceMatchPlusPercentage > 0 and not already in priceMatchRows
        products.forEach(product => {
            const { id, name, priceMatchPlusPercentage, newPrice, status } = product;
            const existsInPriceMatchRows = updatedPriceMatchRows.some(row => row.id === id);
            if (
                status === 1 &&
                priceMatchPlusPercentage > 0 &&
                !existsInPriceMatchRows
            ) {
                this.onAddPriceMatch(id, name, priceMatchPlusPercentage, newPrice, false);
            }
        });
    
        // Remove products from priceMatchRows where priceMatchPlusPercentage is 0 or status is 4
        const filteredPriceMatchRows = updatedPriceMatchRows.filter(row => {
            const product = products.find(p => p.id === row.id);
            return product && product.priceMatchPlusPercentage > 0 && product.status !== 4;
        });
    
        // Update the state with the filtered rows
        if (filteredPriceMatchRows.length !== priceMatchRows.length) {
            this.props.updatePriceMatchRows(filteredPriceMatchRows);
        }
    
        return filteredPriceMatchRows;
    };
    
    getProducts = () => {
        const types = [
            { text: this.props.t('pos.productDiscount.percentage'), value: 'Percentage' },
            { text: this.props.t('common.amount'), value: 'Amount' }
        ];
        const { discounts, stackDiscountsEnabled, priceMatchPlusPercentage } = this.props;
        const data = this.props.products.filter(product => product.status === 1 && (!stackDiscountsEnabled ? product.discountType === null : true)).map((product) => {
            let discount = discounts.find(item => product.id === item.productId);
            const isSalesPerson = this.props.userRole === "SalesPerson" ? true : false
            return {
                Name: product.name,
                OriginalPrice: `${product.newPrice.toFixed(2)}`,
                DiscountType:
                    <SelectInput name={`${this.props.name}Type-${product.id}`}
                        underlineShow={false}
                        className="smallFont"
                        label={this.props.t('pos.productDiscount.discountType')}
                        hintText={this.props.t('pos.productDiscount.discountType')}
                        options={types}
                    />,
                DiscountAmount:
                    (discount && discount.type)
                        ?
                        (discount.type === 'Percentage')
                            ?
                            <MaskedTextInputDiscount
                                underlineShow={true}
                                fullWidth={true}
                                name={`${this.props.name}Percentage-${product.id}`}
                                label={this.props.t('common.discountPerc')}
                                hintText={this.props.t('common.discountPerc')}
                                mask="999"
                                min={0}
                                max={isSalesPerson ? (this.props.saleDiscountCap > 0 ? this.props.saleDiscountCap : 100) : 100}
                                originalPrice={product.newPrice.toFixed(2)}
                            />
                            :
                            (discount.type === 'Amount')
                                ?
                                <DecimalInputDiscount
                                    name={`${this.props.name}Amount-${product.id}`}
                                    underlineShow={true}
                                    hintText={this.props.t('common.discountAmount')}
                                    fullWidth={true}
                                    label={this.props.t('common.discountAmount')}
                                    min={0}
                                    max={isSalesPerson ? (this.props.saleDiscountCap > 0 ? Math.min(product.newPrice, product.newPrice * (this.props.saleDiscountCap / 100)) : product.newPrice) : product.price}
                                    originalPrice={product.newPrice.toFixed(2)}
                                    required />
                                : null
                        : null,

                NewPrice:
                    (discount && discount.type)
                        ?
                        (discount.type === 'Percentage' || discount.type === 'Amount')
                            ?
                            <DecimalInputDiscount
                                name={`${this.props.name}NewPrice-${product.id}`}
                                underlineShow={true}
                                hintText={this.props.t('pos.productDiscount.newPrice')}
                                fullWidth={true}
                                label={this.props.t('pos.productDiscount.newPrice')}
                                min={0}
                                max={product.newPrice}
                                originalPrice={product.newPrice.toFixed(2)}
                                costPrice={product.costPrice}
                                quantity={product.quantity}
                            />
                            : ""
                        : "",
                Note:
                    (discount && discount.type)
                        ?
                        (discount.type === 'Percentage' || discount.type === 'Amount')
                            ?
                            <TextInput
                                name={`${this.props.name}OrderProductNotes-${product.id}`}
                                label={this.props.t('common.note')}
                                required={(this.props.isHighTide || this.props.isInspired)}
                            /> : ""
                        : "",
                ...(priceMatchPlusPercentage !== 0 && priceMatchPlusPercentage !== null &&
                    (product.priceMatchPlusPercentage == 0 || product.priceMatchPlusPercentage == null)
                    ? {
                        PriceMatch: (
                            <ToggleInputForTable
                                name={`${this.props.name}PriceMatch-${product.id}`}
                                className="coupon_status"
                                onToggle={this.onToggleEvent}
                                value={false}
                                onToggleEvent={(value) => {
                                    return this.handleToggleClick(product.id, product.name);
                                 }}
                            />
                        )
                    }
                    : {})

            };
        });

        return data;
    };

    calculateCurrentPrice = (newPrice, priceMatchPlusPercentage) => {
        const currentPrice = newPrice / (1 - priceMatchPlusPercentage / 100);
        return Number(currentPrice.toFixed(2));
    };

    createPriceMatchRow = (productId, productName, currentPrice) => {
        const {priceMatchPlusPercentage}=this.props;
        if (currentPrice === undefined) {
          return null;
        }
    
        const discountAmount = Number((currentPrice * (priceMatchPlusPercentage / 100)).toFixed(2));
        const newPrice = Number((currentPrice - discountAmount).toFixed(2));
    
        return {
          id: productId,
          Name: productName,
          CurrentPrice: currentPrice,
          PriceMatchPlus: priceMatchPlusPercentage,
          DiscountAmount: discountAmount,
          NewPrice: newPrice
        };
      };

      handleToggleClick = (productId, productName) => {
        const { newPrices, priceMatchRows = [], showError, updatePriceMatchRows, removePriceMatchRows } = this.props;
        
        const currentPrice = newPrices[productId];
        if (currentPrice === undefined) {
          showError(this.props.t('pos.productDiscount.priceMatchError'));
          return false;
        }
        const existingRowIndex = priceMatchRows.findIndex(row => row.id === productId);
        
        if (existingRowIndex === -1) {
          const newRow = this.createPriceMatchRow(productId, productName, currentPrice);
          if (newRow) {
            updatePriceMatchRows([...priceMatchRows, newRow]);
          }
        } else {
          removePriceMatchRows(productId);
        }
    
        return true;
      };


      getPriceMatchRows = () => {
        
        const { products = [], priceMatchRows = [], newPrices } = this.props;  
        const newRows = [];
    
        // Iterate through the products to update or add rows
        products.forEach((product) => {
            const { id, status, priceMatchPlusPercentage, name, newPrice } = product;
            let existingRow;
            if (priceMatchRows && priceMatchRows.length > 0 ) {
                if(status != 4 )
                    existingRow = priceMatchRows.find(row => row.id === id );
        }
    
          if ((status === 1 && priceMatchPlusPercentage > 0) || existingRow) {
              const calcprice = this.calculateCurrentPrice(product.newPrice, priceMatchPlusPercentage);
              const currentPrice = newPrices[id] === undefined ? calcprice : newPrices[id];
              newRows.push(this.createPriceMatchRow(id, name, currentPrice));
          }
        });
        
        return newRows;
    };

    render() {
        const { t } = this.props; 

        let tableProductDiscount = [
            { key: "Name", label: t('common.name') },
            { key: "OriginalPrice", label: t('pos.productDiscount.prevPrice') },
            { key: "DiscountType", label: t('pos.productDiscount.discountType') },
            { key: "DiscountAmount", label: t('pos.productDiscount.discountAmountText') },
            { key: "NewPrice", label: t('pos.productDiscount.newPriceIcon') },
            { key: "Note", label: t('common.note') }
        ];
        if (this.props.priceMatchPlusPercentage !== 0 && this.props.priceMatchPlusPercentage !== null) {
            tableProductDiscount.push({ key: "PriceMatch", label: t('pos.productDiscount.priceMatch') });
        }
        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <p>
                            {t('pos.productDiscount.enterDiscountInfo')}
                        </p>
                        <GenericTable
                            compName="ProductsDiscountList"
                            tableBodyClassName="POSProductDiscountList"
                            columns={tableProductDiscount}
                            rows={this.getProducts() || []}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            multiSelectable={false}
                            enableSelectAll={false}
                            selectable={false} />
                    </div>
                </div>
                {/* Conditionally render another GenericTable if priceMatchPlusPercentage exists */}
                {(this.props.priceMatchPlusPercentage !== 0 && this.props.priceMatchPlusPercentage !== null) ? (
                    <div className="row">
                        <div className="col-lg-12">
                            <p>
                                {t('pos.productDiscount.additionalInfoForPriceMatch')}
                            </p>
                            <GenericTable
                                compName="ProductPriceMatchTable"
                                tableBodyClassName="POSProductDiscountList"
                                columns={[
                                    { key: "Name", label: t("common.name") },
                                    { key: "CurrentPrice", label: t("constants.currentPrice") },
                                    { key: "PriceMatchPlus", label: t("constants.priceMatchPlus") },
                                    { key: "DiscountAmount", label: t("pos.productDiscount.discountAmountText") },
                                    { key: "NewPrice", label: t("pos.productDiscount.newPriceIcon") }
                                  ]}
                                rows={this.getPriceMatchRows()}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                multiSelectable={false}
                                enableSelectAll={false}
                                selectable={false}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const newPricesList = Object.keys(state.form)
        .filter(key => key.startsWith("POSProductDiscountNewPrice-"))
        .reduce((obj, key) => {
            const productId = key.split('-')[1]; // Extract productId from the key
            obj[productId] = state.form[key]; // Set productId as key and newPrice as value
            return obj;
        }, {});
    return {
        products: state.entity.posOrder ? state.entity.posOrder.products : [],
        saleDiscountCap: state.common.applicationSettings.salesPersonDiscountThreshold ? state.common.applicationSettings.salesPersonDiscountThreshold : 0,
        userRole: state.common.authenticatedUser.role,
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
        priceMatchPlusPercentage: state.common.applicationSettings.priceMatchPlusPercentage,
        newPrices: newPricesList,
        priceMatchRows: state.entity.priceMatchRows,
        discounts: selectDiscountProducts(state.form, props.name, state.entity.priceMatchRows),
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        updatePriceMatchRows: (priceMatchRows) => dispatch(updatePriceMatchRows(priceMatchRows)),
        removePriceMatchRows: (productId) => dispatch(removePriceMatchRows(productId)),
        clearPriceMatchRows: () => dispatch(clearPriceMatchRows())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductDiscount))